import {useState} from 'react'
import Select from 'react-select';

const AddContentSetting = ({isVisible, setIsVisible, language, contentModelId, contentSettings, setContentSettings}) => {
    const [selectedType, setSelectedType] = useState('')
    const [settingName, setSettingName] = useState('')
    const [settingAlias, setSettingAlias] = useState('')
    const [defaultValue, setDefaultValue] = useState('')
    const [settingDescription, setSettingDescription] = useState('')
    const [showDescription, setShowDescription] = useState(false)
    const types = [{value: 'string', label:'String'},
                    {value: 'bool', label:'Bool'},
                    {value: 'rte', label:'Rte'},
                    {value: 'relation', label:'Relation'}]


    const handleClose = async e => {
        setSelectedType('')
        setSettingName('')
        setSettingAlias('')
        setDefaultValue('')
        setSettingDescription('')
        setShowDescription(false)
        setIsVisible(isVisible ? false : true)
    }

    const selectType = (option) => {
        setSelectedType(option.value)
    }

    const postContentSetting = async () => {

        var graphql = JSON.stringify({
            query: `mutation ($contentModelId: Long
                            , $defaultValue: String
                            , $settingAlias: String
                            , $settingDescription: String
                            , $settingName: String
                            , $settingType: String
                            , $showDescription: Boolean){
                        postContentSetting(contentModelId:$contentModelId
                                        , defaultValue:$defaultValue
                                        , settingAlias:$settingAlias
                                        , settingDescription:$settingDescription
                                        , settingName:$settingName
                                        , settingType:$settingType
                                        , showDescription:$showDescription) {
                            id
                            contentModelId
                            settingAlias
                            settingName
                            settingType
                            defaultValue
                            settingDescription
                            showDescription
                            sortOrder
                        }
                    }`,
            variables: {
                "contentModelId": contentModelId
                ,"defaultValue": defaultValue
                ,"settingAlias": settingAlias
                ,"settingDescription": settingDescription
                ,"settingName": settingName
                ,"settingType": selectedType
                ,"showDescription": showDescription
            }
            
          })
        const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
            method:'POST',
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
                ,'Content-Type': 'application/json'
            },
            body: graphql
        })
        .then(response => response.text())
        .then(result => {
            var resultData = JSON.parse(result).data
            var newList = contentSettings.concat(resultData.postContentSetting)
            setContentSettings(newList)
            handleClose()
            return resultData
        })
        .catch(error => console.log('error', error))
        const data = await res
        
        return data

    }

    const handleSave = async e => {
        e.preventDefault();
        var error = false
        if(settingName === ""){
            error = true
        }
        if(settingAlias === ""){
            error = true
        }
        if(selectedType === ""){
            error = true
        }
        if(!error){
            await postContentSetting()
        }
    }


    return (
        <>
        {(isVisible) && <div id="cc_overlay"></div>}
        <div id="cc_editarticle" className={isVisible ? '' : 'hidden'} >
            <div className="close-container">
                <span className="result_response"></span>
                <button onClick={handleClose}><i className="sprite-icon icon-close"></i></button>
            </div>
            <h3>{language.value === 'DA' ? 'Tilføj' : 'Add'}</h3>
            <div id="cc_article_container">
                <div id="articletype_list">
                    <label className="input_label">
                        <span>Type</span>
                        <Select className="settingTypeSelect" classNamePrefix="settingTypeSelect" options={types} onChange={selectType} placeholder={language.value === 'DA' ? 'Indholds type' : 'Content type'} />
                    </label>                    
                    <label className="input_label">
                        <span>{language.value === 'DA' ? 'Navn' : 'Name'}</span>
                        <input type="text" name="settingName" value={settingName} onChange={ e => setSettingName(e.target.value)} autoComplete="off"/>
                    </label>                    
                    <label className="input_label">
                        <span>Alias</span>
                        <input type="text" name="settingAlias" value={settingAlias} onChange={ e => setSettingAlias(e.target.value)} autoComplete="off"/>
                    </label>                    
                    <label className="input_label">
                        <span>{language.value === 'DA' ? 'Standard værdi' : 'Default value'}</span>
                        <input type="text" name="defaultValue" value={defaultValue} onChange={ e => setDefaultValue(e.target.value)} autoComplete="off"/>
                    </label>                    
                    <label className="input_label">
                        <span>{language.value === 'DA' ? 'Beskrivelse' : 'Description'}</span>
                        <textarea name="settingDescription" value={settingDescription} onChange={ e => setSettingDescription(e.target.value)} autoComplete="off" />
                    </label>                    
                    <label className="input_label">
                        <span>{language.value === 'DA' ? 'Vis beskrivelse' : 'Show description'}</span>
                        <input type="checkbox" name="shopDescription" checked={showDescription} onChange={ e => setShowDescription(showDescription ? false : true) } />
                    </label>                    
                </div>                
                <div className="align_right">
                    <button className="cc-btn blue-gradient" onClick={handleSave}>{language.value === 'DA' ? 'GEM' : 'SAVE'}</button>
                </div>
            </div>
        </div>
        </>
    )
}

export default AddContentSetting
